import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
type Refresh = () => void

interface afterSalesNewReservationItemParams {
  hashItemReserve: string
  refresh: Refresh
  notify: any
  setLoadingAfterSalesReservationItem: React.Dispatch<React.SetStateAction<boolean>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmAfterSalesItem: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenAfterSalesItemModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const afterSalesNewReservationItem = async ({
  hashItemReserve,
  refresh,
  notify,
  setLoadingAfterSalesReservationItem,
  setHashItemReserve,
  setConfirmAfterSalesItem,
  setOpenAfterSalesItemModal,
}: afterSalesNewReservationItemParams): Promise<void> => {
    setLoadingAfterSalesReservationItem(true)
    setOpenAfterSalesItemModal && setOpenAfterSalesItemModal(true)
    await itemServices.createAftersalesItem(hashItemReserve).then(()=>{
      setOpenAfterSalesItemModal && setOpenAfterSalesItemModal(false)
      notify('ra.notification.after_sales_item_success', {
        type: 'success',
      })
      
    }).catch(()=>{
      notify('ra.notification.after_sales_item_error', {
        type: 'error',
      })
    }).finally(()=>{
      setHashItemReserve('')
      setConfirmAfterSalesItem && setConfirmAfterSalesItem(false)
      setLoadingAfterSalesReservationItem(false)
      customAwait([refresh])
    })

}